module.exports = __webpack_public_path__ + "static/media/snt.c3dbc295.svg";